import React, { Component } from 'react'
import { Form, Input, Header, Label, Button, Dropdown, Modal } from 'semantic-ui-react'

import 'react-table/react-table.css'
import 'semantic-ui-css/semantic.min.css'

class BusinessModal extends Component {
    constructor(props) {
        super(props)
        const { selectIndex } = this.props
        this.state = {
            selectIndex: undefined,
            selectedBusiness: {
                name: '',
                brand_id: '',
                address: '',
                website: '',
                phone: '',
            }
        }
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleClose = this.handleClose.bind(this)
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps.selectIndex !== prevState.selectIndex) {
            return {
                ...prevState,
                selectIndex: nextProps.selectIndex,
                selectedBusiness: nextProps.selectedBusiness
            }
        }
        return null
    }
    handleChange(e, {name, value}) {
        let selectedBusiness = this.state.selectedBusiness
        selectedBusiness[name] = value
        this.setState({selectedBusiness: selectedBusiness})
    }
    handleSubmit() {
        const { selectIndex } = this.props;
        const { createBusiness, modifyBusiness } = this.props.businessAction
        const { name, apikey, brand_id, address, website, phone } = this.state.selectedBusiness;
        if (this.check === this.password) {
            if (selectIndex !== undefined && apikey !== undefined) { // modify
                modifyBusiness(apikey, {
                    name: name,
                    brand_id: brand_id,
                    address: address,
                    website: website,
                    phone: phone,
                    expired_at: "",
                    permission_id: ""
                })
            } else { // create
                createBusiness({
                    name: name,
                    apikey: apikey,
                    brand_id: brand_id,
                    address: address,
                    website: website,
                    phone: phone,
                    expired_at: "",
                    permission_id: ""
                })
            }
            this.handleClose()
        }
    }
    handleClose() {
        this.props.toggleModalOpen()
    }
    render() {
        const { isModalOpen, selectIndex, brandOption } = this.props;
        const { selectedBusiness } = this.state;
        const brand_option = [];
        if (brandOption !== undefined && brandOption.length !== 0) {
            brandOption.forEach((brand) => {
                brand_option.push({
                    text: brand.name,
                    value: brand.id
                })
            });
        }
        return (
            <Modal
                open={isModalOpen}
                onClose={this.handleClose}
                size='large'
            >
                <Modal.Content>
                    <Form onSubmit={this.handleSubmit}>
                        <Header size='large'>Business</Header>
                        <Form.Field>
                            <Label>Name</Label>
                            <Input placeholder='Name' type='text' name='name' value={selectedBusiness.name} onChange={this.handleChange} />
                        </Form.Field>
                        <Form.Field>
                            <Label>Brand</Label>
                            <Dropdown
                                placeholder='Type keywords to select brand'
                                search selection
                                options={brand_option}
                                name='brand_id'
                                defaultValue={selectedBusiness.brand_id}
                                onChange={this.handleChange}
                            />
                        </Form.Field>
                        <Form.Field>
                            <Label>Address</Label>
                            <Input placeholder='Address' type='text' name='address' value={selectedBusiness.address} onChange={this.handleChange} />
                        </Form.Field>
                        <Form.Field>
                            <Label>Website</Label>
                            <Input placeholder='Website' type='text' name='website' value={selectedBusiness.website} onChange={this.handleChange} />
                        </Form.Field>
                        <Form.Field>
                            <Label>Phone</Label>
                            <Input placeholder='Phone' type='text' name='phone' value={selectedBusiness.phone} onChange={this.handleChange} />
                        </Form.Field>
                        <Form.Field>
                            <Label>Apikey</Label>
                            <Input placeholder='Apikey (auto-generated)' type='text' name='apikey' readOnly value={selectedBusiness.apikey} />
                        </Form.Field>
                        <Form.Field>
                            <Button type="button" onClick={this.handleClose}>Close</Button>
                            {
                                selectIndex !== undefined ? <Button primary type='submit'>Modify</Button> : <Button primary type='submit'>Register</Button>
                            }
                        </Form.Field>
                    </Form>
                </Modal.Content>
            </Modal>
        )
    }
}

export { BusinessModal }
